import { createCookie, readCookie } from '../../../shared/js/helpers/read-write-cookies';
import {loadFavouriteCookies} from "./helpers/load-favourite-cookies";

let promptUnfavourite = readCookie('prompt-unfavourite') ?? 'true';
let favouriteCookies = loadFavouriteCookies();

const showElement = (element) => {
    element?.classList.remove('hidden');
};

const hideElement = (element) => {
    element?.classList.add('hidden');
};

const updateFavouritesTracker = () => {
    const tracker = document.querySelector('span[data-favourite-count]');
    const favouritesCount = favouriteCookies.length;
    if (tracker) {
        tracker.innerText = favouritesCount;
    }

    const inactiveButtons = document.querySelectorAll('button[data-favourite-id][data-active="false"]');
    inactiveButtons.forEach((button) => {
        if (favouritesCount >= window.MAX_FAVOURITES) {
            button.disabled = true;
        } else {
            button.disabled = false;
        }
    });

    showOrHideSelectHomeDiv();
};

const unFavouriteItem = (button) => {
    const favouriteId = button.dataset.favouriteId;
    favouriteCookies.splice(favouriteCookies.indexOf(favouriteId), 1);

    setActiveAttributeForFavouriteId(favouriteId, 'false');

    createCookie('favourite-displays', JSON.stringify(favouriteCookies), 365);
    removeFavouritable(favouriteId);
    updateFavouritesTracker();
}

const removeFavouritable = (id) => {
    const buttonInCompareHomes = document.querySelector(`#compareHomeDesigns button[data-favourite-id='${id}']`);
    if (buttonInCompareHomes) {
        const favouritable = buttonInCompareHomes.closest('[data-favouritable-card]');
        favouritable?.parentElement?.removeChild(favouritable);
    }
}

const favouriteButtonListener = (event) => {
    const button = event.currentTarget;
    const favouritable = button.closest('[data-favouritable-card]');
    const confirmContainer = favouritable?.querySelector('[data-confirmation-container]');

    if (button.dataset.active === 'true') {
        if (confirmContainer && promptUnfavourite === 'true') {
            confirmContainer.dataset.active = 'true';
        } else {
            unFavouriteItem(button);
        }
    } else {
        const favouriteId = button.dataset.favouriteId;
        if (!favouriteCookies.includes(favouriteId) && (favouriteCookies.length < window.MAX_FAVOURITES)) {
            favouriteCookies.push(favouriteId);
            button.dataset.active = 'true';

            createCookie('favourite-displays', JSON.stringify(favouriteCookies), 365);
            addFavouritableCardToCompareHomes(favouritable);
            setActiveAttributeForFavouriteId(favouriteId, 'true');
            updateFavouritesTracker();
        }
    }
}

const setActiveAttributeForFavouriteId = (favouriteId, activeValue) => {
    const buttonsWithId = document.querySelectorAll(`button[data-favourite-id='${favouriteId}']`);
    buttonsWithId.forEach((buttonWithId) => {
        buttonWithId.dataset.active = activeValue;
    });
};

const addFavouritableCardToCompareHomes = (favouritable) => {
    let theClone = favouritable.cloneNode(true);

    if (!favouritable.closest('#featureDisplays')) {
        const id = favouritable?.getAttribute('data-home-id');
        if (id) {
            theClone = document
                .querySelector('#hiddenSlides')
                ?.querySelector(`[data-stacked="true"] [data-favouritable-card][data-home-id="${id}"]`)
                ?.cloneNode(true);
        }
    }
    
    if (!theClone) {
        return;
    }

    // If the clone is from a slider, the scale class needs to be removed first
    theClone.classList.remove('scale-[.8]');

    const compareHomesDiv = document.querySelector('#compareHomeDesigns');
    setupFavouritableCardListeners(theClone);
    compareHomesDiv?.appendChild(theClone);
};

const confirmFavouriteRemovalEventListener = (event) => {
    const confirmButton = event.currentTarget;
    const favouritable = confirmButton.closest('[data-favouritable-card]');
    const confirmContainer = favouritable?.querySelector('[data-confirmation-container]');
    setPromptUnfavouriteCookie(confirmContainer);

    const button = favouritable?.querySelector('button[data-favourite-id]');
    const id = button.getAttribute("data-favourite-id");
    unFavouriteItem(button);
    confirmContainer.dataset.active = false;
}

const closeConfirmationEventListener = (event) => {
    const button = event.currentTarget;
    const favouritable = button.closest('[data-favouritable-card]');
    const confirmContainer = favouritable?.querySelector('[data-confirmation-container]');
    confirmContainer.dataset.active = 'false';
}

const setPromptUnfavouriteCookie = (container) => {
    const dontShowAgain = container?.querySelector('input[type="checkbox"]');

    if (dontShowAgain.checked) {
        createCookie('prompt-unfavourite','false',365);
        promptUnfavourite = 'false';
    }
}

const showOrHideSelectHomeDiv = () => {
    const selectHomeDiv = document.querySelector("#selectHome");
    if (favouriteCookies.length >= window.MAX_FAVOURITES) {
        hideElement(selectHomeDiv);
    } else {
        selectHomeDiv?.parentElement?.appendChild(selectHomeDiv);
        showElement(selectHomeDiv);
    }
};

export const setupFavouritableCardListeners = (favouritableCard) => {
    let favouriteButtons = favouritableCard.querySelectorAll('button[data-favourite-id]');
    favouriteButtons.forEach((button) => {
        const confirmContainer = favouritableCard?.querySelector('[data-confirmation-container]');

        //check cookies if an elevation has been favourited & apply visual based on result of above check
        if (favouriteCookies.indexOf(button.dataset.favouriteId) !== -1) {
            button.dataset.active = 'true';
        }

        button.addEventListener('pointerdown', favouriteButtonListener);

        if (confirmContainer) {
            confirmContainer.querySelector('button[data-confirm-removal]').addEventListener('pointerdown', confirmFavouriteRemovalEventListener);
            confirmContainer.querySelector('button[data-close-confirmation]').addEventListener('pointerdown', closeConfirmationEventListener);
        }
    });
};

const setupSystemReset = () => {
    const systemResetButton = document.querySelector("#systemReset");
    systemReset?.addEventListener("pointerdown", () => {
        const favouritedButtons = document.querySelectorAll('#compareHomeDesigns button[data-favourite-id]');
        favouritedButtons.forEach((favouritedButton) => {
            unFavouriteItem(favouritedButton);
        });
    });
};

const setupOnLoad = () => {
    const favouritableCards = document.querySelectorAll('[data-favouritable-card]');
    favouritableCards.forEach((favouritableCard) => {
        setupFavouritableCardListeners(favouritableCard);
    });
}

window.addEventListener('load', event => {
    // MAIN CODE
    setupOnLoad();
    updateFavouritesTracker();
    setupSystemReset();
});